module.exports = __webpack_public_path__ + "5c114213/img/link-icon.fa09ed66.svg";